__turbopack_context__.v({
  "icon": "page-module__UBdgra__icon",
  "termContent": "page-module__UBdgra__termContent",
  "termHeader": "page-module__UBdgra__termHeader",
  "termSection": "page-module__UBdgra__termSection",
  "terms": "page-module__UBdgra__terms",
  "title": "page-module__UBdgra__title",
});
